import Model, { attr, belongsTo } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type Partner from 'teacher-ui-client/models/partner'
import type School from 'teacher-ui-client/models/school'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import type StringTransform from 'teacher-ui-client/transforms/string'

/**
 * Relates a school to a partner with subscription type.
 * A school can have multiple partners (eg one for reading, one for maths) or the same partner for both.
 */
export default class SchoolPartner extends Model {
  @attr<StringTransform>('string') declare subscriptionType: SubscriptionType

  @belongsTo<School>('school', { async: false, inverse: 'schoolPartners' }) declare school?: School

  @belongsTo<Partner>('partner', { async: false, inverse: 'schoolPartners' }) declare partner?: Partner;

  [Type] = 'school-partner' as const
}
